module.exports = __webpack_public_path__ + "img/header-weddingRingsFancy.e389e63.webp";